<template>
  <!-- 套餐商品详情 -->
  <div :class="['Package-goods',product.type==1||(product.type==2 && !product.is_buy)?'on':'']" v-if="bodyShow">
    <div class="header">
      <!-- banner -->
      <img class="banner" :src="product.image" />
      <ul class="text">
        <li v-for="(item,index) in highlights" :key="index">
          <span v-if="item">·</span>
          {{item}}
        </li>
      </ul>
    </div>
    <!-- package-title -->
    <div class="package-title">
      <h2>{{product.name}}</h2>
      <h3>{{product.brief}}</h3>
      <h4 v-show="!hide_payment">
        <sup v-show="product.price>product.discount_price">限时优惠</sup>
        <span>￥{{product.discount_price/100}}</span>
        <del v-if="product.price>product.discount_price">原价 ¥{{product.price/100}}</del>
      </h4>
    </div>
    <!-- package-list -->
    <div class="package-list">
      <!--单个测评 -->
      <div v-if="product.type==1">
        <!-- 测评介绍 -->
        <div  v-html="product.description" class="list-content"></div>
      </div>
      <!-- 套餐详情 -->
      <div v-if="product.type==2">
        <div class="list-header">
          <label for="details" :class="['details',menuTab==1?'on':'']">
            <input id="details" :value="1" v-model="menuTab" type="radio" />套餐详情
          </label>
          <label for="introduce" :class="['introduce',menuTab==2?'on':'']">
            <input id="introduce" :value="2" v-model="menuTab" type="radio" />测评介绍
          </label>
        </div>
        <!-- tabs-content -->
        <div class="tab-content">
          <!-- list -->
          <div v-if="menuTab==1">
            <!-- 套餐详情 -->
            <div class="list" v-for="(item,index) in list" :key="index" @click="is_buy = item.is_buy;toReport(item.link,item.order_id,item.id)">
              <img class="product-img" :src="item.image" />
              <div class="list-right">
                <h3 class="text-ellipsis">{{item.name}}</h3>
                <p class="text-ellipsis">{{item.brief}}</p>
                <!-- redReport -->
                <h4 v-if="item.evaluation_id">
                  <span class="p1" >
                    查看报告
                    <img src="@a/ms_system/my-right2.png" />
                  </span>
                </h4>
                <h4 v-else-if="item.is_buy">
                  <span class="p2">继续测评</span>
                </h4>
                <h4 v-else>{{item.buy_count}} 人已测</h4>
              </div>
            </div>
          </div>
          <!-- 测评介绍 -->
          <div v-if="menuTab==2" v-html="product.description"  class="list-content"></div>
        </div>
      </div>
    </div>
    <!-- pay button -->
    <!-- 单个商品 -->
    <div v-if="product.activity_count > 0" class="goods-btn-group" v-show="!hide_payment">
        <a v-if="!product.evaluation_id" class="pay-button btn-orange" @click="start">开始测评</a>
        <a v-else class="pay-button btn-orange"  @click="toReport(product.link, product.order_id)">查看报告</a>
    </div>
    <div v-else-if="product.type==1">
        <!-- <a v-if="payComplete(product.progress)==2" @click="toReport(product.link)" class="pay-button">查看报告</a> -->
        <!-- 路由带兑换码 -->
        <a v-if="routerCode && $route.query.code && product.evaluation_id" class="pay-button"  @click="toReport(product.link, product.order_id)">查看报告</a>
        <a v-else-if="routerCode && $route.query.code" class="pay-button"  @click="toReport(product.link)">开始测评</a>
        <!--  -->
        <!-- 2021年1月7日 17点33分  修改按钮为两个   兑换码购买 begin -->
        <div  class="goods-btn-group" v-show="!hide_payment" v-if="product.pay_type==0">
          <a v-if="product.evaluation_id || product.is_buy" class="pay-button"  @click="codePayHandle(product.link)">兑换码支付</a>
          <a v-else class="pay-button"  @click="codePayHandle(product.link,'onePay')">兑换码支付</a>
          <!-- 兑换码购买 end -->
          <!-- 现金支付 -->
          <a v-if="product.evaluation_id" class="pay-button"  @click="modePayment(product.link)">现金支付</a>
          <a v-else-if="product.is_buy" @click="modePayment(product.link)" class="pay-button">现金支付</a>
          <!-- 第一次购买传参onePay -->
          <a v-else class="pay-button"  @click="modePayment(product.link,'onePay')">现金支付</a>
        </div>
        <div  class="goods-btn-group" v-show="!hide_payment" v-else>
          <a v-if="product.evaluation_id || product.is_buy" class="pay-button"  @click="codePayHandle(product.link)">兑换码支付</a>
          <a v-else class="pay-button"  @click="codePayHandle(product.link,'onePay')">兑换码支付</a>
        </div>
    </div>
    <!-- 套餐商品 -->
    <div v-if="product.type==2 && !redReportBool">
      <!-- 2021年1月7日 17点33分  修改按钮为两个   兑换码购买 begin -->
      <div  class="goods-btn-group" v-show="!hide_payment" v-if="product.pay_type == 0">
        <a  class="pay-button"  @click="codePayHandle(product.link,'onePay')">兑换码支付</a>
        <!-- 路由带兑换码 -->
        <a class="pay-button" v-if="!product.is_buy" @click="modePayment()">现金支付</a>
        <a class="pay-button" v-else @click="modePayment()">现金支付</a>
      </div>
      <div  class="goods-btn-group" v-show="!hide_payment" v-else>
        <a  class="pay-button"  @click="codePayHandle(product.link,'onePay')">兑换码支付</a>
      </div>
    </div>
    
    <!-- 支付方式 -->
    <van-popup v-model="payModelShow" position="bottom" >
      <div class="payModel">
        <h3>{{!codepay?'请选择兑换码支付':'请选择支付方式'}}</h3>
        <div :class="['payGroup',payModel=='code'?'on':'']">
          <div v-if="product.pay_type==0 && codepay" class="payChild" @click="payModel = 'cash'">
            <img src="@a/ms_system/cash.png" alt="">现金支付
            <span :class="['check',payModel=='cash'?'on':'']"></span>
          </div>
          <div :class="['payChild payChild2',!conversionError && payModel=='code'?'on2':(payModel=='code'?'on':'')]" @click="payModel ='code'">
            <img src="@a/ms_system/Conversion_code.png" alt="">兑换码支付
            <span :class="['check',payModel=='code'?'on':'']"></span>
            <input v-if="payModel=='code'" v-model="conversionCode" type="text" placeholder="请输入兑换码">
          </div>
          <!-- 兑换码错误 -->
          <span v-show="conversionError && payModel=='code'" :class="['conversion-error']">
            <img src="@a/ms_system/error.png">{{conversionText?conversionText:"兑换码错误，请核实！"}}
          </span>
        </div>
        <a @click="continuePay()" class="payModelBtn">立即支付</a>
      </div>
    </van-popup>
    <!-- 确认重复支付 -->
    <van-popup v-model="isPayShow" >
      <div class="repeat-payment">
        <h3 v-if="routerPath_">嗨，你已购买过{{continueStr?continueStr:'该测评'}}，是否确认继续支付？（重复支付不予退款）</h3>
        <h3 v-else>嗨，你已完成过{{continueStr?continueStr:'该测评'}}，是否确认继续支付？（重复支付不予退款）</h3>
        <div class="repeat-payment">
          <a class="repeat-payment-left" @click="proceedPay()">继续支付</a>
          <a v-if="routerPath_ && product.evaluation_id"  class="repeat-payment-right" @click="redReport()">查看报告</a>
          <a v-else  class="repeat-payment-right" @click="toReport()">继续测评</a>
        </div>
      </div>
    </van-popup>
    <van-popup v-model="showDialog" :close-on-click-overlay="false">
      <div class="dialog-box">
        <div class="box1 flex-col">
          <div class="bd1 flex-col">
            <div class="outer1 flex-row">
              <span class="word2">完善信息去测评</span>
              <div class="block1 flex-col">
                <div class="outer2 flex-col" @click="showDialog = false">
                  <img
                    class="icon-close"
                    referrerpolicy="no-referrer"
                    src="../../../assets/ms_activity/close.png"
                  />
                </div>
              </div>
            </div>
            <div class="outer3 flex-col">
              <div class="group1 flex-row">
                <div class="layer3 flex-col">
                  <img
                    class="icon1"
                    referrerpolicy="no-referrer"
                    src="../../../assets/ms_activity/icon1.png"
                  />
                </div>
                <span class="txt2"><input class="txt" type="text" placeholder="输入姓名" v-model="extra.name"></span>
              </div>
            </div>
            <div class="outer4 flex-col">
              <div class="mod1 flex-row">
                <div class="outer5 flex-col">
                  <div class="wrap1 flex-col">
                    <div class="bd2 flex-col"></div>
                  </div>
                </div>
                <span class="word3"><input class="txt" type="tel" placeholder="输入您的手机号" v-model="extra.phone"></span>
              </div>
            </div>
            <div class="outer6 flex-col">
              <div class="main3 flex-row">
                <div class="outer7 flex-col">
                  <div class="block2 flex-col">
                    <div class="wrap2 flex-row">
                      <div class="section4 flex-col"></div>
                      <div class="section5 flex-col"></div>
                      <div class="section6 flex-col"></div>
                    </div>
                  </div>
                </div>
                <span class="txt3"><input class="txt" type="number" placeholder="输入验证码" v-model="extra.code"></span>
              </div>
            </div>
            <div class="outer8 flex-col" :class="{disabled: !extra.name || !extra.phone || !extra.code}" @click="submit"><span class="info2">提交</span></div>
          </div>
          <div class="bd3 flex-col" :class="{disabled: time > 0 || !extra.phone}" @click="sendCode"><span class="txt4">{{btnText}}</span></div>
        </div>
      </div>
    </van-popup>
    <!-- 如果是电脑打开支付 -->
    <van-popup v-model="qrCodeBool">
      <div class="qrcode-box">
        <div id="qrcode"></div>
        <p>请使用微信扫一扫支付</p>
        <!-- btn -->
        <div class="qrcode-btn">
          <a @click="checkPayHandle()" href="javascript:;">已支付</a>
          <a @click="qrCodeBool=false" href="javascript:;">取消</a>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { ext_goods_detail,ext_exchange,ext_check_order_status } from "@/api/measurement_system";
import { send_sms,check_sms } from "@/api/xuandui_gadgets";
import { ext_buy_product } from "@/api/pay";
import { ceping_activity_submit } from "@/api/other";
import { setSessionStorage,getSessionStorage,goAuthLogin,isWeixin,delParam,time,strtotime } from "@u/tools";
import wx from "weixin-js-sdk";
export default {
  data() {
    return {
      bodyShow: false,
      list: [],
      product: {},
      menuTab: 1,
      payModelShow:false,
      payModel:'',
      conversionCode:'',
      conversionError:false,
      conversionText:'',
      // 确认是否重复支付
      continueStr:'',
      isPayShow:false,
      // 存储报告的地址
      report_link:'',
      // 如果是已有套餐内商品
      redReportBool:false,
      // 继续测评跳转路由
      routerPath_:'',
      // 是否购买当前点击的测评
      is_buy:false,
      // 路由是否带有code并且兑换成功
      routerCode:false,
      authorizer_appid: null,
      // 微信支付二维码
      qrCodeBool:false,
      // 存储微信支付页面二维码时间
      wxcodeTime:'',
      // 设置兑换码支付
      codepay:true,
      showDialog: false,
      extra: {
        name: '',
        phone: '',
        code: '',
      },
      btnText: '获取验证码',
      time: 0,
      sms_info: {},
      hide_payment: false
    }
  },
  mounted(){
    /**
     * 处理iOS 微信客户端6.7.4 键盘收起页面未下移bug
     */
    (/iphone|ipod|ipad/i.test(navigator.appVersion)) && document.addEventListener('blur', (e) => {
        // 这里加了个类型判断，因为a等元素也会触发blur事件
        ['input', 'textarea'].includes(e.target.localName) && document.body.scrollIntoView(false)
    }, true)

    if(this.$route.query.hide_payment == "1") {
      this.hide_payment = true;
    }
  },
  computed: {
    /*
     *@param:
     *@return:
     *@Description: 替换亮点里边的换行
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-16 16:00:07
     */
    highlights() {
      let h = this.product.highlights;
      return h ? h.replace(/\n/g, "/n").split("/n") : [];
    }
  },
  methods: {
    start() {
      if(this.product.activity_count > 0) {
        this.is_buy = this.product.is_buy;
        this.toReport(this.product.link);
      } else {
        this.toReport(this.product.link);
      }
    },
    showModal() {
      let now = time();
      if(this.product.activity_start) {
        let start_time = strtotime(this.product.activity_start);
        if(now < start_time) {
          this.$toast('活动未开始');
          return;
        }
      }
      if(this.product.activity_start) {
        let end_time = strtotime(this.product.activity_end);
        if(now > end_time) {
          this.$toast('活动已结束');
          return;
        }
      }
      if(this.product.activity_count) {
        if(this.product.buy_count >= this.product.activity_count) {
          this.$toast('活动名额已满');
          return;
        }
      }
      this.showDialog = true;
    },
    /*
     *@param: 
     *@return: 
     *@Description: 继续支付
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2021-01-08 09:55:27
    */
    proceedPay(){
      // this.isPayShow = false;
      // this.payModelShow=true;
      // 隐藏继续支付提示
      this.codepay = false;
      // 是否为兑换码支付
      if(this.payModel=='code'){
        this.payModelShow = true;
      }else{
        this.continuePay();
      }
      
    },
    /*
     *@param: 
     *@return: 
     *@Description: 兑换码支付
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2021-01-07 17:55:15
    */
    codePayHandle(link,payCount){
      this.payModel = 'code';
      // list.length>0  为套餐商品
      if(this.list && this.list.length>0){
        let bool = false;
        this.continueStr = '套餐商品里的';
        for(let i=0;i<this.list.length;i++){
          // 
          if(this.list[i].ordr_id){
            this.continueStr+=(this.list[0].ordr_id && i>0?'、':'')+this.list[i].name;
            bool = true;
          }
        }
        if(bool){
          
          this.isPayShow = true;
        }else{
          this.codepay = false;
          this.payModelShow = true;
        }
      }else{
        if(this.product.order_id){
          this.routerPath_ = link;
          this.isPayShow = true;
        }else{
          this.codepay = false;
          this.payModelShow = true;
        }
      }

      


      // this.routerPath_ = link;
      // this.isPayShow = true;
    },
    /*
     *@param: 
     *@return: 
     *@Description: 检查当前微信二维码订单是否支付
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2020-10-15 17:23:12
    */
    checkPayHandle(){
      ext_check_order_status({
        product_id:this.product.id,
        datetime:this.wxcodeTime
      }).then(data=>{
        if(data.code=='10002'){
          this.$toast(data.data.msg);
          return
        }
        if(!data.status || !data.id){
          this.$toast('未找到订单！');
        }else if(data.status==-1){
          this.$toast('订单已失效！');
          this.qrCodeBool = false;
        }else if(data.status==2){
          this.$toast('请先支付订单！');
          this.qrCodeBool = false;
        }else if(data.status==1){
          this.$toast('订单已失效！');
          this.$router.go(0);
        }
      });
    },
    // 取消继续支付查看报告
    redReport(){
      if(this.list && this.list.length>0){
        this.isPayShow = false;
        setSessionStorage(this.$route.path,'redReportBool',true);
        this.redReportBool = true;
      }else{
        if(this.product.link.indexOf("_report")==-1){
          this.$router.push(this.product.link+'_report?order_id=' + this.product.order_id);
        }else{
          this.$router.push(this.product.link + '?order_id=' + this.product.order_id);
        }
        
      }
    },
    /*
     *@Description: 如完成测评查看报告否则继续答题
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-11 18:09:21
     */
    toReport(link,order_id,goods_id) {
      if(this.routerCode && this.$route.query.code){
        this.$router.push(link);
        return
      }
      // 判断是否有报告
      if(order_id){
        if(link.indexOf("_report")>-1){
          this.$router.push(link + '?order_id=' + order_id);
        }else{
          this.$router.push(link+'_report?order_id='+order_id);
        }
        // 判断是否购买
      }else if(this.is_buy){
        this.$router.push(link + '?order_id=' + this.product.order_id);
      // 跳转测评商品页面
      }else if(this.routerPath_){
        this.$router.push(this.routerPath_ + '?order_id=' + this.product.order_id);
      // 跳转测评商品页面
      }else if (goods_id) {
        let str = window.location.href.split('id=');
        window.location.href = str[0]+`id=${goods_id}`;
      } else {
        this.showModal();
      }
    },
    /*
     *@param: progress 进度
     *@return:
     *@Description: 判断支付完成和完成测评进度
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-16 16:05:44
     */
    payComplete(progress) {
      if (this.product.is_buy) {
        if (progress >= 100) {
          return 2;
        } else {
          return 3;
        }
      } else {
        return 1;
      }
    },
    /*
     *@param: link 继续测评的跳转路由、payCount 判断是否是第一次购买
     *@return: 
     *@Description: 支付方式
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-30 12:12:25
    */
    modePayment(link,payCount){
      // 现金支付，初始化兑换码支付属性
      this.codepay = true;
      this.payModel ='cash';
      // continueStr
      if(this.list && this.list.length>0){
        let b = false;
        this.continueStr = '套餐商品里的';
        for(let i=0;i<this.list.length;i++){
          // 
          if(this.list[i].order_id){
            this.continueStr+=(this.list[0].order_id && i>0?'、':'')+this.list[i].name;
            b = true;
          }
        }
        if(b){
          
          this.isPayShow = true;
        }else{
          // 修改为底部两个按钮，支付调用代码 begin
          this.continuePay();
           // 修改为底部两个按钮，支付调用代码 end
          // this.payModelShow = true;
        }
      }else{
        // 判断是否已有完成过测评
        if(this.product.order_id){
          this.routerPath_ = link;
          this.isPayShow = true;
        }else{
          // 判读那是否是点击继续测评按钮
          if(link && payCount=='onePay'){
            this.routerPath_ = link;
            // 修改为底部两个按钮，支付调用代码 begin

            this.continuePay();
            // 修改为底部两个按钮，支付调用代码 end
            // this.payModelShow = true;
          }else{
            this.routerPath_ = link;
            this.isPayShow = true;
          }
          
        }
      }
      
    },
    /*
     *@param:str 路由参数
     *@return:
     *@Description: 继续支付
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-16 15:11:08
     */
    continuePay(str){
        if(this.payModel=='code' || str=='routeCode'){
          ext_exchange({
            code:this.conversionCode,
            product_id:this.product.id
          }).then(data=>{
            // 如果是路由带参
            if(str && str=='routeCode'){
              if(data.code=='10002'){
                this.$toast(data.data.msg);
                return
              }
              this.routerCode=true;
            }else{
              if(data.code=='10002'){
                this.conversionText = data.data.msg || data.msg || '请求失败';
                this.conversionError = true;
                // this.$toast(data.data.msg);
                return
              }
              this.payModelShow = false;
              this.$toast({
                message:'兑换成功！3秒后自动刷新或跳转',
                onClose:()=>{
                  if(this.routerPath_ || this.product.link){
                    this.$router.push((this.routerPath_?this.routerPath_:this.product.link)+'?order_id='+data.id);
                  }else{
                    if(this.$route.query.paySource==='pc'){
                      location.href = delParam('paySource');
                    }else{
                      this.$router.go(0);
                    }
                  }
                  
                }
              });
            }
            
          });
        }else{
          // 是否是微信
          if(!isWeixin()){
            this.qrCodeBool = true;
            if(document.getElementById("qrcode")){
              document.getElementById("qrcode").innerHTML="";
            }
            
            setTimeout(()=>{
              let qrcode = new QRCode(document.getElementById("qrcode"),{
                width: '250',
                height: '250'
              });
              qrcode.makeCode(window.location.href+"&paySource=pc");
              // 当前日期时间
              let d = new Date(); 
              let year_ =  d.getFullYear().toString(),
              Month_ = (d.getMonth() + 1).toString(),
              day_ = d.getDate().toString(),
              hours_ = d.getHours().toString(),
              minutes_ = (d.getMinutes().toString()),
              seconds_ = d.getSeconds().toString();
              this.wxcodeTime = year_+'-'+Month_+'-'+day_+' '+hours_+':'+minutes_+':'+seconds_;
            }, 500)
            
          }else{
            this.payHandle();
          }
          
        } 
    },
    /*
     *@param:
     *@return:
     *@Description: 支付
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-16 15:11:08
     */
    payHandle() {
      this.$toast({
        type: "loading",
        mask: true,
        message: "加载中..."
      });
      ext_buy_product({
        id: this.product.id,
        pay_config_id: this.product.pay_config_id,
        authorizer_appid: this.authorizer_appid,
      }).then(data => {
        let data_ = eval("(" + data.jsApiParameters + ")");
        let jsApiCall = () => {
          WeixinJSBridge.invoke("getBrandWCPayRequest", data_, rest => {
            this.$toast.clear();
            WeixinJSBridge.log(rest.err_msg);
            if (rest.err_msg == "get_brand_wcpay_request:ok") {
              this.payModelShow = false;
              this.$toast({
                message:'兑换成功！3秒后自动刷新或跳转',
                onClose:()=>{
                   if(this.routerPath_ || this.product.link){
                    this.$router.push((this.routerPath_?this.routerPath_:this.product.link)+'?order_id='+data.id);
                  }else{
                    if(this.$route.query.paySource==='pc'){
                      location.href = delParam('paySource');
                    }else{
                      this.$router.go(0);
                    }
                    
                  }
                }
              });
            } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
              alert("支付取消");
            } else {
              alert("支付失败");
            }
          });
        };

        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener("WeixinJSBridgeReady", jsApiCall, false);
          } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", jsApiCall);
            document.attachEvent("onWeixinJSBridgeReady", jsApiCall);
          }
        } else {
          jsApiCall();
        }
      });
    },
    /*
     *@param:
     *@return:
     *@Description: 初始化数据
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-12-16 15:10:54
     */
    pullData() {
      // loading
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      ext_goods_detail({
        id: this.$route.query.id
      }).then(data => {
        if(data.code=='10002'){
          this.$toast(data.data.msg);
          return
        }
        if(data.product.pay_config && !data.product.pay_config.openid) {
          return goAuthLogin('绑定第三方OPENID', data.product.pay_config.app_id);
        } else if (data.product.pay_config) {
          this.authorizer_appid = data.product.pay_config.app_id
        }
        this.data = data;
        this.product = data.product;
        if(this.product.activity_count > 0) {
          this.is_buy = this.product.is_buy;
        }
        document.title = this.product.name;
        this.payModel = this.product.pay_type==0?'cash':'code';
        this.list = data.list;
        this.isRouterCode();
        this.bodyShow = true;
        this.$toast.clear();
        // 如果是pc带过来直接走支付
        if(this.$route.query.paySource==='pc'){
          this.payHandle();
        }
      });

      if(getSessionStorage(this.$route.path,'redReportBool')!= undefined){
        this.redReportBool = getSessionStorage(this.$route.path,'redReportBool');
      }

      

    },
    // 判断是否存在code
    isRouterCode(){
      if(this.$route.query.code){
        this.conversionCode = this.$route.query.code;
        this.continuePay('routeCode');
      }
    },
    submit() {
      if(!this.extra.name) {
        this.$toast('请输入姓名');
        return;
      }
      if(!this.extra.phone) {
        this.$toast('请输入手机号');
        return;
      }
      if(!this.extra.code) {
        this.$toast('请输入验证码');
        return;
      }

      check_sms({sms_id: this.sms_info.sms_id, code: this.extra.code}).then(res=>{
          if(res.error>0) {
            return Promise.reject(res.msg);
          }
          if(this.sms_info.phone != this.extra.phone) {
            return Promise.reject('请重新验证');
          }
          this.do_submit();
        }).catch(msg=>{
          if(!msg) {
            this.$toast(msg);
          }
        });
    },
    do_submit() {
      ceping_activity_submit({
        id: this.product.id,
        name: this.extra.name,
        phone: this.extra.phone,
        source: this.$route.query.source || null,
      }).then(data=>{
        if(data.code=='10002'){
            this.$toast(data.data.msg);
            return;
          }
          this.showDialog = false;
          this.is_buy = true;
          this.$toast('提交成功');

          setTimeout(()=>{
            if(this.routerPath_ || this.product.link){
              this.$router.push(this.routerPath_?this.routerPath_:this.product.link);
            }else{
              if(this.$route.query.paySource==='pc'){
                location.href = delParam('paySource');
              }else{
                this.$router.go(0);
              }
            }
          }, 1000);
      });
    },
    sendCode() {
      if(this.time > 0) {
        return;
      }

      if(!this.extra.phone) {
        this.$toast('请输入手机号');
        return;
      } else if (!/^1[3-9][0-9]{9}$/.test(this.extra.phone)) {
        this.$toast('手机号码不正确');
        return;
      }

      send_sms({mobile: this.extra.phone}).then(res=>{
        if(res.error > 0) {
          if(res.msg) {
            this.$toast(res.msg);
          }
          return;
        }

        this.sms_info.phone = this.extra.phone;
        this.sms_info.sms_id = res.sms_id;

        this.time = 60;
        this.btnText = `${this.time}s`;
        let t = setInterval(()=>{
          if(this.time > 0) {
            this.time--;
            this.btnText = `${this.time}s`;
          } else {
            clearInterval(t);
            this.btnText = '重新发送';
          }
        }, 1000);
      }).catch(msg=>{
        if(!msg) {
          this.$toast(msg);
        }
      });
    },
  },
  created() {
    this.pullData();
  }
};
</script>

<style lang="scss" scoped>
.dialog-box {
  width: 670px;
  height: 700px;
  background: #FFFFFF;
  border-radius: 40px;

  .txt {
      background: none;
      border: none;
      outline: none;
      color: #2B333A;
      // display: block;
      // box-sizing: border-box;
      // width: 100%;

      &::placeholder {
        color: #A9AFB3;
      }
  }

  .flex-col {
    display: flex;
    flex-direction: column;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
  }

  .box1 {
    z-index: 17;
    height: 700px;
    border-radius: 40px;
    background-color: rgba(255, 255, 255, 1);
    width: 670px;
    justify-content: flex-start;
    align-items: flex-end;
    position: relative;
    padding: 30px 30px 0 0;
  }
  .bd1 {
    z-index: auto;
    width: 580px;
    height: 610px;
  }
  .outer1 {
    z-index: auto;
    width: 431px;
    height: 80px;
    margin-left: 149px;
    justify-content: space-between;
  }
  .word2 {
    z-index: 51;
    width: 252px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(44, 40, 36, 1);
    font-size: 36px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 50px;
    text-align: center;
    margin-top: 30px;
  }
  .block1 {
    z-index: 19;
    height: 40px;
    background-color: rgba(255, 255, 255, 0);
    width: 40px;
    justify-content: center;
    align-items: center;
  }
  .outer2 {
    z-index: 21;
    width: 30px;
    height: 30px;
  }
  .icon-close {
    width: 30px;
    height: 30px;
  }
  .outer3 {
    z-index: 44;
    height: 88px;
    border-radius: 44px;
    background: #F7F8F9;
    align-self: flex-start;
    margin-top: 50px;
    width: 550px;
    justify-content: center;
    align-items: flex-start;
    padding-left: 30px;
  }
  .group1 {
    z-index: auto;
    width: 170px;
    height: 42px;
    justify-content: space-between;
  }
  .layer3 {
    z-index: 47;
    height: 40px;
    background-color: rgba(43, 51, 58, 0);
    width: 40px;
    justify-content: center;
    align-items: center;
  }
  .icon1 {
    z-index: 48;
    width: 28px;
    height: 31px;
  }
  .txt2 {
    z-index: 45;
    width: 120px;
    display: flex;
    align-items: center;
    overflow-wrap: break-word;
    color: rgba(169, 175, 179, 1);
    font-size: 30px;
    white-space: nowrap;
    line-height: 42px;
    text-align: left;
  }
  .outer4 {
    z-index: 23;
    height: 88px;
    border-radius: 44px;
    background-color: rgba(247, 248, 249, 1);
    align-self: flex-start;
    margin-top: 30px;
    width: 550px;
    justify-content: center;
    align-items: flex-start;
    padding-left: 30px;
  }
  .mod1 {
    z-index: auto;
    width: 260px;
    height: 42px;
    justify-content: space-between;
  }
  .outer5 {
    z-index: 26;
    height: 40px;
    background-color: rgba(43, 51, 58, 0);
    width: 40px;
    justify-content: center;
    align-items: center;
  }
  .wrap1 {
    z-index: 27;
    height: 36px;
    border-radius: 6px;
    border-width: 2px;
    border: 2px solid rgba(43, 51, 58, 1);
    width: 26px;
    justify-content: flex-end;
    padding-bottom: 5px;
    align-items: center;
  }
  .bd2 {
    z-index: 28;
    width: 8px;
    height: 2px;
    border-radius: 1px;
    background-color: rgba(43, 51, 58, 1);
  }
  .word3 {
    z-index: 24;
    width: 210px;
    display: flex;
    align-items: center;
    overflow-wrap: break-word;
    color: rgba(169, 175, 179, 1);
    font-size: 30px;
    white-space: nowrap;
    line-height: 42px;
    text-align: left;
  }
  .outer6 {
    z-index: 33;
    height: 88px;
    border-radius: 44px 0 0 44px;
    background: #F7F8F9;
    align-self: flex-start;
    margin-top: 30px;
    width: 417px;
    justify-content: center;
    align-items: flex-start;
    padding-left: 30px;
  }
  .main3 {
    z-index: auto;
    width: 200px;
    height: 42px;
    justify-content: space-between;
  }
  .outer7 {
    z-index: 36;
    height: 40px;
    background-color: rgba(43, 51, 58, 0);
    margin-top: 1px;
    width: 40px;
    justify-content: center;
    align-items: center;
  }
  .block2 {
    z-index: 37;
    height: 26px;
    border-radius: 6px;
    border-width: 2px;
    border: 2px solid rgba(43, 51, 58, 1);
    width: 34px;
    justify-content: center;
    align-items: center;
  }
  .wrap2 {
    z-index: auto;
    width: 20px;
    height: 4px;
    justify-content: space-between;
  }
  .section4 {
    z-index: 38;
    width: 4px;
    height: 4px;
    background-color: rgba(43, 51, 58, 1);
    border-radius: 50%;
  }
  .section5 {
    z-index: 39;
    width: 4px;
    height: 4px;
    background-color: rgba(43, 51, 58, 1);
    border-radius: 50%;
  }
  .section6 {
    z-index: 40;
    width: 4px;
    height: 4px;
    background-color: rgba(43, 51, 58, 1);
    border-radius: 50%;
  }
  .txt3 {
    z-index: 34;
    width: 150px;
    display: flex;
    align-items: center;
    overflow-wrap: break-word;
    color: rgba(169, 175, 179, 1);
    font-size: 30px;
    white-space: nowrap;
    line-height: 42px;
    text-align: left;
  }
  .outer8 {
    z-index: 30;
    height: 96px;
    border-radius: 48px;
    background: linear-gradient(180deg, #FF9726 0%, #FF7200 100%);
    align-self: flex-start;
    margin-top: 60px;
    width: 550px;
    justify-content: center;
    align-items: center;

    &.disabled {
        background: linear-gradient(180deg, #E8E8E8 0%, #C9C9C9 100%);
    }
  }
  .info2 {
    z-index: 31;
    width: 64px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 32px;
    white-space: nowrap;
    line-height: 45px;
    text-align: center;
  }
  .bd3 {
    z-index: 41;
    height: 88px;
    border-radius: 0 44px 44px 0;
    background: linear-gradient(180deg, #FF9726 0%, #FF7200 100%);
    width: 200px;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 410px;
    top: 396px;

    &.disabled {
        background: linear-gradient(180deg, #E8E8E8 0%, #C9C9C9 100%);
    }
  }
  .txt4 {
    z-index: 42;
    width: 150px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 30px;
    white-space: nowrap;
    line-height: 42px;
    text-align: center;
  }
}
// 支付方式样式
.payModel{
  border-radius:48px 48px 0px 0px;
  padding: 60px 40px 80px 40px;
  background-color: #ffffff;
  h3{
    font-size: 34px;
    color: #333333;
    margin-bottom: 40px;
  }
  .payGroup{
    display: flex;
    flex-direction: column;
    .payChild{
      padding: 40px 0;
      display: flex;
      font-size: 34px;
      flex-wrap: wrap;
      align-items: center;
      border-bottom: 2px solid #eeeeee;
      &:last-of-type{
        border-bottom: 0;
      }
      img{
        width: 40px;
        height: 40px;
        margin-right: 20px;
      }
      .check{
        display: block;
        width: 32px;
        height: 32px;
        border:2px solid #cccccc;
        border-radius: 50%;
        margin-left: auto;
      }
      .check.on{
        background-image: url('../../../assets/ms_system/check.png');
        background-size: 100% 100%;
        border:0;
        background-repeat: no-repeat;
      }
      input{
        width: 670px;
        line-height: 70px;
        border-radius:8px;
        border: 2px solid #cccccc;
        margin: 20px auto 0;
        padding: 0 22px;
        font-size: 26px;
      }
    }
    .payChild.payChild2{
      padding-bottom: 260px;
    }
    .payChild.payChild2.on2{
      padding-bottom: 38px;
    }
    .payChild.payChild2.on{
      padding-bottom: 14px;
    }
    .conversion-error{
      display: flex;
      align-items: center;
      font-size: 24px;
      line-height: 1;
      color: #EB5032;
      img{
        width: 24px;
        height: 24px;
        margin-left: 22px;
        margin-right: 20px;
      }
    }
  }
  .payGroup.on{
    padding-bottom: 130px;
  }
  .payModelBtn{
    line-height: 80px;
    width: 578px;
    font-size: 34px;
    color: #ffffff;
    background-color: #EB5032;
    border-radius: 8px;
    display: block;
    text-align: center;
    margin: 0 auto;
  }
}
.Package-goods {
  background-color: #f0f0f0;
  .header {
    position: relative;
    font-size: 0;
    .banner {
      max-width: 750px;
      width: 100%;
      height: 400px;
    }
    ul.text {
      position: absolute;
      bottom: -2px;
      left: 0;
      height: 62px;
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
      padding: 0 38px;
      background: rgba(255, 255, 255, 0.5);
      li {
        font-size: 22px;
        height: 100%;
        display: flex;
        align-items: center;
        span {
          font-size: 30px;
          font-weight: 400;
          margin-right: 5px;
        }
      }
    }
  }
  .package-title {
    padding: 30px;
    text-align: center;
    background-color: #ffffff;
    margin-bottom: 20px;
    h2 {
      font-size: 32px;
      color: #333333;
      font-weight: bold;
      margin-bottom: 20px;
    }
    h3 {
      font-size: 24px;
      color: #666666;
      margin-bottom: 28px;
    }
    h4 {
      span {
        font-size: 32px;
        color: #eb5032;
        margin-right: 10px;
      }
      del {
        font-size: 22px;
        color: #666666;
      }
      sup {
        font-size: 22px;
        color: #eb5032;
        margin-right: 5px;
      }
    }
  }
  .package-list {
    background-color: #ffffff;
    padding-bottom:98px;
    .list-header {
      padding: 30px 30px 0 30px;
      display: flex;
      label {
        display: block;
        text-align: center;
        flex: 1;
        background-color: #f57f17;
        color: #ffffff;
        font-size: 30px;
      }
      label.on {
        background-color: #ffffff;
        color: #f57f17;
        border: 2px solid #f57f17;
      }
      input[type="radio"] {
        display: none;
      }
      label.details {
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;
      }
      label.introduce {
        border-top-right-radius: 6px;
        border-bottom-right-radius: 6px;
      }
    }
    .tab-content {
      .list {
        display: flex;
        padding: 30px;
        border-bottom: 1px solid #cccccc;
        &:last-child {
          border-bottom: 0;
        }
        img.product-img {
          width: 200px;
          height: 150px;
          margin-right: 20px;
        }
        .list-right {
          width: 470px;
          display: flex;
          flex-direction: column;
          h3 {
            font-size: 30px;
            color: #333333;
            line-height: 1;
            margin-bottom: 15px;
          }
          p {
            font-size: 24px;
            color: #666666;
            line-height: 1;
            margin-bottom: 56px;
          }
          h4 {
            font-size: 28px;
            color: #666666;
            line-height: 1;
            width: max-content;
            .p1 {
              display: flex;
              align-items: center;
              color: #eb5032;
              img {
                width: 14px;
                height: 24px;
                margin-left: 6px;
              }
            }
            .p2 {
              color: #f57f17;
            }
          }
        }
      }
      .list-content {
        padding: 30px;
        img {
          width: 100%;
        }
      }
    }
  }
  .goods-btn-group{
    width: 100%;
    max-width: 750px;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    .pay-button {
      background-color: #eb5032;
      color: #ffffff;
      font-size: 34px;
      text-align: center;
      line-height: 98px;
      flex: 1;
      &:first-child{
        border-right: 2px solid #ffffff;
      }
      &.btn-orange {
        background: linear-gradient(180deg, #FF9726 0%, #FF7200 100%);
      }
    }
  }
  
  .van-popup{
    background-color: transparent;
  }
}
.Package-goods.on{
    padding-bottom: 98px;
}
// pc打开支付
.qrcode-box{
  background-color: #ffffff;
  width: 600px;
  border-radius: 12px;
  padding: 50px;
  text-align: center;
  img{
    margin: 0 auto;
  }
  #qrcode{
    text-align: center;
    margin: 0 auto;
  }
  p{
    font-size: 26px;
    text-align: center;
    color: #666666;
    margin-top: 30px;
  }
  .qrcode-btn{
    display: flex;
    margin-top: 30px;
    justify-content: center;
    a{
      display: block;
      width: 150px;
      line-height: 70px;
      border-radius: 30px;
      background-color: #EB5032;
      color: #ffffff;
      font-size: 30px;
      text-align: center;
      &:last-child{
        margin-left: 40px;
        background-color: #cccccc
      }
    }
  }
}
.repeat-payment{
  background-color: #ffffff;
  width: 600px;
  border-radius: 12px;
  padding: 50px;
  h3{
    text-align: justify;
    font-size: 30px;
  }
  .repeat-payment{
    display: flex;
    justify-content:space-evenly;
    width: 100%;
    font-size: 26px;
    margin-top: 40px;
    padding: 0;
    .repeat-payment-left{
      padding: 0 30px;
      background-color: #eb5032;
      color: #ffffff;
      border-radius: 25px;
      line-height: 60px;
    }
    .repeat-payment-right{
      padding: 0 30px;
      background-color: #eb5032;
      color: #ffffff;
      border-radius: 25px;
      line-height: 60px;
    }
  }
}
</style>
<style lang="scss" >
.Package-goods .package-list{
  .list-content {
    padding: 30px;
    img {
      width: 100%;
    }
  }
}
// pc打开支付
.qrcode-box{
  img{
    margin: 0 auto;
  }
}
</style>